var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 136,
    viewBox: "0 0 161 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.519 77.6204C158.219 78.4204 153.819 79.7204 154.719 80.3204C154.719 80.3871 154.752 80.4204 154.819 80.4204C155.619 80.9204 158.219 81.5204 160.319 81.8204C160.319 81.9537 160.319 82.1204 160.319 82.3204C160.319 82.6537 160.286 82.9871 160.219 83.3204C160.152 83.7871 160.086 84.1537 160.019 84.4204C159.119 88.0204 56.4189 135.52 54.5189 135.12C52.5189 134.62 15.7189 105.92 13.0189 98.1204C12.1189 95.3204 11.5189 89.5204 11.1189 83.2204C18.0189 87.0204 30.9188 93.9204 31.1189 92.0204C31.2189 89.9204 16.5189 76.4204 10.6189 72.3204C10.3189 64.5204 10.3188 58.2204 10.3188 58.2204C10.6188 57.7204 12.4188 56.9204 15.3188 55.9204C34.7188 49.0204 104.519 31.1204 114.219 30.9204C121.019 30.9204 160.219 57.1204 160.219 57.1204C160.219 57.1204 160.219 57.2871 160.219 57.6204C160.219 57.6871 160.219 57.8204 160.219 58.0204C160.286 58.3538 160.319 58.7871 160.319 59.3204C160.319 59.7871 160.319 60.3204 160.319 60.9204C160.319 61.1204 160.319 61.3204 160.319 61.5204C160.386 62.0537 160.419 62.6204 160.419 63.2204V63.7204C156.319 66.0204 147.919 71.0204 146.219 73.6204C144.619 75.9204 154.019 74.2204 160.519 72.2204C160.519 74.1204 160.519 75.9204 160.519 77.6204Z",
    fill: "url(#paint0_linear_62_890)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1189 83.2204C11.1189 83.2204 20.6189 76.5204 24.6189 78.2204C28.6189 80.0204 37.7189 96.4204 37.7189 96.4204C37.7189 96.4204 33.9189 100.52 32.4189 100.02C30.9189 99.5204 11.1189 83.2204 11.1189 83.2204Z",
    fill: "#404C29"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.719 56.7204C147.719 62.6204 127.819 70.8204 107.119 77.3204C104.586 78.1204 102.086 78.8871 99.6188 79.6204C79.3188 85.5204 59.8188 89.5204 55.6188 87.7204C44.3188 83.1204 15.3188 55.9204 15.3188 55.9204C23.1188 53.1204 39.1189 48.6204 56.0189 44.1204C59.5189 43.2204 63.0189 42.3204 66.5189 41.4204C88.3188 35.8204 109.219 31.0204 114.219 30.9204C121.019 30.9204 154.519 52.5204 151.719 56.7204Z",
    fill: "#9193BA"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.519 72.2205C160.519 72.2205 149.419 66.5205 146.219 68.0205C143.019 69.5205 141.419 76.4205 141.419 76.4205L148.919 78.0205L160.519 72.2205Z",
    fill: "#404C29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.319 81.8205C160.319 81.8205 154.419 77.3205 153.419 78.0205C152.419 78.8205 150.519 81.8205 150.519 81.8205L158.919 83.0205L160.319 81.8205Z",
    fill: "#404C29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.519 77.6204C158.219 78.4204 153.819 79.7203 154.719 80.3203C154.719 80.387 154.752 80.4203 154.819 80.4203C155.719 80.9203 160.119 81.5203 160.319 81.8203H160.419C160.352 81.9537 160.319 82.1203 160.319 82.3203C160.319 82.6537 160.286 82.987 160.219 83.3203C160.152 83.787 160.086 84.1537 160.019 84.4203C159.619 86.1203 136.619 97.5204 112.219 109.12C106.919 111.62 101.519 114.12 96.3189 116.62C74.5189 126.72 55.3189 135.32 54.5189 135.12C52.5189 134.62 15.7189 105.92 13.0189 98.1204C12.1189 95.3204 11.5189 89.5203 11.1189 83.2203C18.0189 87.0203 30.9188 93.9204 31.1189 92.0204C31.2189 89.9204 16.5189 76.4203 10.6189 72.3203C10.3189 64.5203 10.3188 58.2203 10.3188 58.2203C10.3188 58.2203 50.6189 90.7204 56.7188 91.0204C60.6189 91.3204 79.1189 85.4204 99.5189 78.6204C101.986 77.7537 104.452 76.887 106.919 76.0204C133.419 66.9204 160.219 57.1204 160.219 57.1204C160.219 57.1204 160.219 57.287 160.219 57.6204C160.219 57.687 160.219 57.8204 160.219 58.0204C160.286 58.3537 160.319 58.787 160.319 59.3203C160.319 59.787 160.319 60.3203 160.319 60.9203C160.319 61.1203 160.319 61.3204 160.319 61.5204C160.386 62.0537 160.419 62.6203 160.419 63.2203C160.419 63.4203 160.419 63.587 160.419 63.7203V63.9203C160.419 63.8537 160.419 63.787 160.419 63.7203C156.319 66.0203 147.919 71.0204 146.219 73.6204C144.619 75.9204 154.019 74.2203 160.519 72.2203C160.519 74.1203 160.519 75.9204 160.519 77.6204Z",
    fill: "url(#paint1_linear_62_890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.219 94.5203C111.219 94.0203 146.019 78.8203 150.519 78.2203C155.019 77.7203 115.219 95.9203 112.219 94.5203Z",
    fill: "#9193BA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4189 96.6203C97.7189 81.1203 144.819 66.3203 146.219 68.0203C147.519 69.8203 66.9189 97.4203 68.4189 96.6203Z",
    fill: "#9193BA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8188 129.92C70.8188 128.82 152.419 89.2204 155.419 85.7204C158.519 82.2204 126.019 93.7204 108.219 100.02C91.7188 105.92 64.4188 124.22 58.6188 129.22C58.2188 129.62 57.8188 129.92 57.8188 129.92Z",
    fill: "#9193BA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4189 93.2204C58.9189 97.4204 93.7189 94.2205 110.519 88.1205C127.319 82.0205 162.219 62.6204 158.419 61.2204C154.619 59.7204 119.719 74.0204 106.619 77.5204C93.5189 80.9204 59.7189 91.2204 59.4189 93.2204Z",
    fill: "#9193BA"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7188 91.0205C55.6189 93.4205 56.0189 133.02 54.5189 135.12C52.5189 134.62 15.7189 105.92 13.0189 98.1205C12.1189 95.3205 11.5189 89.5205 11.1189 83.2205C18.0189 87.0205 30.9188 93.9205 31.1189 92.0205C31.2189 89.9205 16.5189 76.4205 10.6189 72.3205C10.3189 64.5205 10.3188 58.2205 10.3188 58.2205C10.3188 58.2205 50.6189 90.7205 56.7188 91.0205Z",
    fill: "url(#paint2_linear_62_890)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.819 45.3203C141.819 45.3203 159.519 55.8203 160.219 57.1203C161.019 58.4203 149.119 61.2203 149.119 61.2203C149.119 61.2203 158.219 57.7203 157.019 56.1203C155.819 54.5203 141.419 45.3203 141.419 45.3203H141.819Z",
    fill: "#C2E238"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M158.419 29.8204C158.319 33.9204 132.619 59.3204 111.719 71.9204C107.819 74.2204 104.119 76.2204 100.719 77.4204C99.1856 78.0204 97.719 78.4538 96.319 78.7204C76.019 82.6204 61.519 86.2204 58.319 84.0204C55.919 82.3204 21.419 56.0205 7.01895 45.1205C6.95228 45.1205 6.91895 45.1205 6.91895 45.1205C3.51895 42.4205 1.21895 40.7204 0.918945 40.4204C2.11895 40.9204 28.719 51.0204 56.519 44.7204C90.019 37.0204 106.519 0.320435 106.519 0.320435C106.519 0.320435 123.919 9.72044 138.619 17.9204C138.619 17.9204 138.619 17.9538 138.619 18.0204C149.219 23.9204 158.419 29.2204 158.419 29.8204Z",
    fill: "url(#paint3_linear_62_890)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.719 77.4203C99.1857 78.0203 97.719 78.4537 96.319 78.7203C76.019 82.6203 61.519 86.2204 58.319 84.0204C55.919 82.3204 21.419 56.0204 7.01904 45.1204C9.01904 46.5204 52.419 78.7204 59.419 82.6204C64.919 85.7204 88.619 78.8204 100.719 77.4203Z",
    fill: "#BEEF31"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M158.419 29.8205C158.319 33.9205 132.619 59.3205 111.719 71.9205L110.119 72.3205C110.119 72.3205 121.619 64.5205 133.519 54.9205C145.419 45.3205 158.519 31.0205 156.219 29.8205C154.019 28.6205 139.719 18.7205 138.619 18.0205C149.219 23.9205 158.419 29.2205 158.419 29.8205Z",
    fill: "#BEEF31"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.319 58.5204C94.2189 62.8204 86.4189 61.6204 82.0189 57.2204C78.4189 53.6204 78.5188 48.6204 81.1188 47.1204C86.6188 43.8204 93.2188 45.6204 96.4188 47.1204C99.9188 48.7204 106.319 54.3204 100.319 58.5204Z",
    fill: "#C2E238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.419 37.7204C144.419 37.7204 130.319 55.0204 105.819 69.3204C90.819 78.0204 70.819 80.2204 70.819 80.2204C70.819 80.2204 70.719 75.3204 64.019 73.8204C58.019 72.5204 55.619 76.8204 55.619 76.8204L16.519 49.9204C17.019 50.1204 25.519 53.2204 28.019 51.8204C30.919 50.1204 26.319 47.9204 26.319 47.9204C26.319 47.9204 56.719 49.6204 69.719 42.5204C91.019 30.9204 99.319 18.4204 100.219 16.6204C100.219 16.6204 105.219 18.3204 108.719 16.6204C112.819 14.6204 113.119 9.92041 113.119 9.92041L145.519 26.5204C145.519 26.5204 139.719 28.5204 140.219 32.9204C140.619 36.7204 144.419 37.7204 144.419 37.7204ZM99.319 43.8204C94.419 41.6204 84.319 38.8204 75.819 43.8204C71.819 46.1204 71.619 53.8204 77.319 59.4204C84.019 66.0204 96.019 67.9204 105.219 61.4204C114.519 54.8204 104.719 46.3204 99.319 43.8204Z",
    fill: "#C2E238"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.319 116.62C100.619 111.22 100.319 85.4204 99.619 79.6204C99.519 78.6204 85.419 68.0204 76.119 61.2204C70.019 56.7204 59.019 47.2204 56.919 45.1204C56.6524 44.8538 56.519 44.7204 56.519 44.7204L56.019 44.1204C59.519 43.2204 63.019 42.3204 66.519 41.4204L105.819 69.3204L106.919 76.0204L107.119 77.3204L112.219 109.12C106.919 111.62 101.519 114.12 96.319 116.62Z",
    fill: "#543404"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.919 111.72C113.819 114.62 106.119 116.62 101.419 117.82C100.619 118.02 99.9189 118.154 99.3189 118.22C96.4189 118.42 95.9189 116.92 95.9189 116.92C95.9189 116.92 97.6189 116.22 99.3189 115.42C99.3856 115.42 99.4189 115.387 99.4189 115.32C100.619 113.52 102.019 79.4205 102.119 78.2205C102.186 78.0205 102.119 77.7205 101.919 77.3205C101.519 76.7205 61.0189 43.1205 59.7189 43.1205L56.0189 44.1205C56.0189 44.1205 55.5189 43.2205 55.6189 42.5205C55.6189 42.2205 56.7189 41.7205 58.2189 41.1205H58.3189C61.3189 39.9205 65.9189 38.4205 68.0189 38.3205C71.1189 38.1205 116.619 67.5205 117.519 72.4205C118.219 76.4205 114.019 108.92 113.919 111.72Z",
    fill: "url(#paint4_linear_62_890)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M101.019 117.02C100.619 117.42 100.019 117.82 99.3189 118.22C96.4189 118.42 95.9189 116.92 95.9189 116.92H96.0189C96.2189 116.82 97.7189 116.22 99.3189 115.42C99.3856 115.42 99.4189 115.387 99.4189 115.32C100.619 113.52 102.019 79.4205 102.119 78.2205C102.186 78.0205 102.119 77.7205 101.919 77.3205C101.519 76.7205 61.0189 43.1205 59.7189 43.1205L56.0189 44.1205C56.0189 44.1205 55.5189 43.2205 55.6189 42.5205C55.6189 42.2205 56.7189 41.7205 58.2189 41.1205H58.3189C59.1189 41.0205 59.9189 41.0205 60.4189 41.3205C77.0189 52.5205 103.519 75.5205 103.519 76.2205C104.319 82.3205 102.319 115.92 101.019 117.02Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M112.519 110.62C111.519 113.62 104.819 116.32 103.919 113.22C102.919 110.22 104.219 79.0204 106.619 77.5204C109.019 76.0204 115.919 72.6204 116.519 75.7204C117.119 78.8204 114.119 106.02 112.519 110.62Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0189 78.2204C16.1189 72.3204 10.7189 60.3204 13.7189 61.9204C16.7189 63.5204 39.4189 82.1204 51.4189 92.0204C54.2189 94.4204 57.2189 105.02 51.0189 103.42C44.9189 101.72 27.0189 85.4204 21.0189 78.2204Z",
    fill: "#9193BA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.519 99.1204C12.719 96.0204 10.619 87.4204 14.519 88.1204C18.419 88.8204 54.919 105.92 54.719 107.32C54.319 109.82 41.419 105.32 38.419 105.82C35.719 106.22 46.319 114.12 53.019 120.12C57.619 124.22 52.819 130.12 51.719 130.12C47.619 130.22 18.419 105.92 14.519 99.1204Z",
    fill: "#9193BA"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4189 69.3203C24.4189 69.3203 46.6189 89.4203 56.7189 91.0203C62.8189 92.0203 82.4189 84.2203 82.4189 84.2203C82.4189 84.2203 61.6189 90.0203 56.7189 89.0203C48.6189 87.3203 24.4189 69.3203 24.4189 69.3203Z",
    fill: "#C2E238"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4189 106.22C38.4189 106.22 51.7189 117.72 55.6189 118.22C59.4189 118.82 87.7189 108.02 85.4189 107.92C83.2189 107.72 64.9189 112.72 57.9189 112.22C50.9189 111.72 42.6189 105.82 38.4189 106.22Z",
    fill: "#912774"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M156.419 70.3203C156.419 70.3203 159.019 71.7203 158.819 72.1203C158.519 72.4203 149.819 74.4203 148.519 74.7203C147.219 75.0203 159.719 73.7203 160.519 72.2203C160.819 71.7203 156.419 70.3203 156.419 70.3203Z",
    fill: "#A7B138"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M155.819 80.7204C155.819 80.7204 159.119 81.4204 158.919 81.1204C158.619 80.7204 158.419 80.4204 158.419 80.4204C158.419 80.4204 160.519 81.6204 160.319 81.8204C160.219 81.9204 156.419 81.1204 155.819 80.7204Z",
    fill: "#A7B138"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0189 51.5204C85.2189 46.9204 104.419 7.0204 109.019 6.6204C113.719 6.3204 155.319 27.1204 154.419 31.8204C153.619 36.5204 101.919 54.8204 95.0189 51.5204Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.819 46.5205C15.319 54.0205 58.919 82.2205 67.619 83.0205C76.219 83.8205 92.119 70.7205 83.619 66.5205C75.119 62.4205 11.519 42.4205 12.819 46.5205Z",
    fill: "#91A674"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1189 116.42C98.6189 116.82 95.9189 116.92 95.9189 116.92H96.019C96.219 116.82 97.719 116.22 99.319 115.42C99.419 115.82 99.4189 116.22 99.1189 116.42Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M103.719 73.3204C108.219 74.1204 113.719 69.1204 112.019 67.8204C110.219 66.4204 70.119 38.8204 68.419 39.3204C66.819 39.8204 98.719 72.5204 103.719 73.3204Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M102.419 75.1204C102.119 74.8204 105.919 74.6204 105.919 75.5204C105.919 76.3204 103.519 78.8204 103.519 78.1204C103.619 77.4204 104.819 76.6204 102.419 75.1204Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.119 94.5204C12.219 95.0204 43.219 121.82 44.519 120.62C45.919 119.52 17.019 93.8204 14.119 94.5204Z",
    fill: "#9193BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_890",
    x1: 10.3668,
    y1: 30.9684,
    x2: 160.542,
    y2: 30.9684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84A61D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_62_890",
    x1: 10.3668,
    y1: 57.1504,
    x2: 160.542,
    y2: 57.1504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#427038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#636F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_62_890",
    x1: 10.3668,
    y1: 58.2065,
    x2: 56.6819,
    y2: 58.2065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#427038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405C06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_62_890",
    x1: 0.883945,
    y1: 0.281434,
    x2: 158.391,
    y2: 0.281434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84A61D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_62_890",
    x1: 55.5769,
    y1: 38.3095,
    x2: 117.609,
    y2: 38.3095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameMode);
export default __webpack_public_path__ + "static/media/game_mode.0a8eefcd80bda61b5486ca731d7887fd.svg";
export { ForwardRef as ReactComponent };